import { createFileRoute } from '@tanstack/react-router'

import GuestContainer from '@/components/pages/guest/containers/GuestContainer'
export const Route = createFileRoute('/_guest')({
  component: GuestContainer
})
